/* MUI */
import { Button, ModalFooter } from '@auviknetworks/iceberg-ui';
import { Box } from '@mui/material';

/* React */
import React from 'react';
import { useFormContext } from 'react-hook-form';

/* NPM */
import { useTranslation } from 'react-i18next';

/**
 * This file is the same as ModalFormFooter with the exception of how useFormContext is imported
 *
 * To use the component, it must be wrapped in a <Form> component from '@auviknetworks/iceberg-ui'
 * which provides the react-hook-form context provider for useFormContext.
 */
export const ModalFormFooterIceberg = ({
    'data-trackid': dataTrackid = 'modalForm',
    onClose,
    onCloseBtnText,
    onSubmitBtnText
}) => {
    const { t } = useTranslation();
    const { formState } = useFormContext();
    const { isSubmitting } = formState;

    return (
        <ModalFooter>
            <Button
                data-testid="modalFooterIcebergOnCloseBtn"
                data-trackid={`${dataTrackid}_footerCancelBtn`}
                onClick={onClose}
                type="button"
                variant="secondary"
            >
                {onCloseBtnText || t('Common.close')}
            </Button>
            <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                width="100%"
            >
                <Button
                    data-testid="modalFooterIcebergSubmitBtn"
                    data-trackid={`${dataTrackid}_footerSaveBtn`}
                    type="submit"
                    variant="primary"
                    loading={isSubmitting}
                >
                    {onSubmitBtnText || t('Common.save')}
                </Button>
            </Box>
        </ModalFooter>
    );
};
